import moment from 'moment'
import accounting from 'accounting'
import store from '../store/index.js'
import Compressor from 'compressorjs';
import {post,get} from '../services/index.js';
import Vue from 'vue'

export function formatDate(date){
  if (!date){
    return ''
  }else{
    if (store.getters.getCurrentLanguage == '') {
      return moment(date).format('ddd, DD MMM YYYY');    
    }else{
      return moment(date).locale(store.getters.getCurrentLanguage).format('ddd, DD MMM YYYY');
    }
  }
};

// date : the date that to be convert
// date_desc : date format description
// moment_string : date format to be used
export function customFormatDateTime(date,date_desc='null',moment_string="DD MMM YYYY, h:mm a"){
  if (!date){
    return ''
  }else{
    if (store.getters.getCurrentLanguage == ''){
      if (date_desc=='null') {
        return moment(date).format(moment_string)
      }
      return moment(date,date_desc).format(moment_string)
    }else{
      if (date_desc=='null') {
        return moment(date).locale(store.getters.getCurrentLanguage).format(moment_string)
      }
      return moment(date,date_desc).locale(store.getters.getCurrentLanguage).format(moment_string)
    }

  }

};


export function formatCurrency(value,no_base_rate=false,real_time=false,currency,base_price){
  var options={
    symbol: (real_time) ? currency.symbol_native : store.getters.getCurrency.symbol_native,
    precision: (real_time) ? currency.digit : store.getters.getCurrency.digit
  }


  let cal_val = (real_time) ? base_price * value : store.getters.getBaseRate.a * value

  if(no_base_rate){
    cal_val = value
  }

  return accounting.formatMoney(cal_val, options)
};

const RATE_PRECISION = 2;
const SMALL_RATE_PRECISION = 6;

/**
 * @param {Object} payment payment channel carrying charge_currency_code
 * @param {string} baseCurrencyCode merchant base currency
 * @returns {boolean} true when the channel bills in a currency other than the base
 */
export function isConvertedCharge(payment, baseCurrencyCode) {
  const { charge_currency_code: chargeCurrencyCode } = payment || {};
  return !!chargeCurrencyCode && chargeCurrencyCode !== baseCurrencyCode;
}

/**
 * @param {Object} payment payment channel with charge_currency_code, bookeepingrate, digit_currency
 * @param {number} baseAmount amount in merchant base currency, surcharge included
 * @param {string} baseCurrencyCode merchant base currency
 * @param {string|number} [chargeAmountOverride] final charge amount from tx-inquiry, preferred over the estimate
 * @returns {{currencyCode: string, amountLabel: string, rateLabel: string}}
 */
export function buildChargeInfo(payment, baseAmount, baseCurrencyCode, chargeAmountOverride) {
  const { charge_currency_code: chargeCurrencyCode, bookeepingrate, digit_currency: digitCurrency } = payment;
  const rate = Number(bookeepingrate);
  const hasOverride = chargeAmountOverride !== undefined && chargeAmountOverride !== null && chargeAmountOverride !== '';
  const amount = hasOverride ? Number(chargeAmountOverride) : baseAmount * rate;

  return {
    currencyCode: chargeCurrencyCode,
    amountLabel: accounting.formatMoney(amount, { symbol: `${chargeCurrencyCode} `, precision: digitCurrency }),
    rateLabel: formatRateLabel(rate, baseCurrencyCode, chargeCurrencyCode)
  };
}

/**
 * @param {Object} payments tx-detail payments carrying charge_* amounts already converted by the server
 * @returns {{currencyCode: string, amount: number, amountLabel: string, rateLabel: string}|null} null when nothing is billed in a foreign currency
 */
export function buildTxChargeInfo(payments) {
  const {
    base_currency_code: baseCurrencyCode,
    charge_currency_code: chargeCurrencyCode,
    charge_amount: chargeAmount,
    charge_deposit: chargeDeposit,
    charge_surcharge: chargeSurcharge,
    bookeepingrate,
    digit_currency: digitCurrency
  } = payments || {};
  if (!isConvertedCharge({ charge_currency_code: chargeCurrencyCode }, baseCurrencyCode)) return null;

  // nothing is charged online when the whole stay is payable at hotel
  const deposit = Number(chargeDeposit) || 0;
  if (deposit <= 0) return null;

  // charge_amount is the exact amount locked and sent to the PG; summing the parts can drift by rounding
  const amount = Number(chargeAmount) || deposit + (Number(chargeSurcharge) || 0);
  return {
    currencyCode: chargeCurrencyCode,
    amount,
    amountLabel: accounting.formatMoney(amount, { symbol: `${chargeCurrencyCode} `, precision: Number(digitCurrency) || 0 }),
    rateLabel: formatRateLabel(Number(bookeepingrate), baseCurrencyCode, chargeCurrencyCode)
  };
}

function formatRateLabel(rate, baseCurrencyCode, chargeCurrencyCode) {
  const ratePrecision = rate < 1 ? SMALL_RATE_PRECISION : RATE_PRECISION;
  return `1 ${baseCurrencyCode} = ${accounting.formatNumber(rate, ratePrecision)} ${chargeCurrencyCode}`;
}

/**
 * @param {Object[]} payments selectable payment channels
 * @param {Object} chargeInfoById charge info keyed by payment id, converted channels only
 * @returns {Object|null} shared charge info when every channel bills in the same foreign currency
 */
export function getUniformChargeInfo(payments, chargeInfoById) {
  if (payments.length === 0) return null;

  const firstInfo = chargeInfoById[payments[0].id];
  if (!firstInfo) return null;

  const isUniform = payments.every(({ id }) => chargeInfoById[id] && chargeInfoById[id].currencyCode === firstInfo.currencyCode);
  return isUniform ? firstInfo : null;
}

export const IDR_CURRENCY_CODE = 'IDR';

/**
 * @param {Object} chargeInfoById charge info keyed by payment id, converted channels only
 * @returns {Object} map of payment id to true for channels converted into IDR
 */
export function getIdrConvertedIds(chargeInfoById) {
  return Object.keys(chargeInfoById).reduce((ids, id) => {
    if (chargeInfoById[id].currencyCode === IDR_CURRENCY_CODE) ids[id] = true;
    return ids;
  }, {});
}

// type :  - "number" : only numeric input is allowed
// 		   - "number_dot" : only numeric and dot input is allowed
// 		   - "number_dash" : only numeric and dot input is allowed
export function inputCustomOnly(type,$event) {
  let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

  if (type === "number" && (keyCode < 48 || keyCode > 57)) { 
    $event.preventDefault();
  }

  if (type === "number_dot" && (keyCode < 48 || keyCode > 57) && keyCode !== 46) { 
    $event.preventDefault();
  }

  if (type === "number_dash" && (keyCode < 48 || keyCode > 57) && keyCode !== 45) { 
    $event.preventDefault();
  }

  if (type === "number_dot_comma" && (keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) { 
    $event.preventDefault();
  }
 }

export function checkDataExist(data){
	let result = true
	if (typeof(data) == 'undefined') {
		return false
	}
	return result
}

export function paymentMethodConverter(payment){
  let data = ''
  if (payment === 'CREDIT_CARD') {
    data = 'Credit Card'
  }else if(payment === 'VIRTUAL_ACCOUNT'){
    data = 'Bank Transfer'
  }else if(payment === 'QRIS'){
    data = 'QRIS'
  }
  return data
}

export function compressImage(file){
  return new Promise((resolve)=>{
    new Compressor(file,{
      convertSize: 2000000,
      quality: 0.6,
      success(result){
        resolve(result)
      },
      error(err) {
        resolve(false)
      },
    })
  })
}

export function checkRestaurantIncDec(variant,payload,cart){
  return new Promise((resolve)=>{
    for (let j = 0; j < variant.length; j++) {
      if (JSON.stringify(cart[variant[j]].topping.sort(function (a, b) {
        return a.topping_index - b.topping_index;
      })) == JSON.stringify(payload.topping.sort(function (a, b) {
        return a.topping_index - b.topping_index
      }))) {
        resolve(variant[j])
      }else{
        resolve(false)
      }
    }
  })
}


export function checkDateCheckInOutExp(){
  let copied = JSON.parse(JSON.stringify(store.getters.getBeFilter))
  let today = Vue.prototype.$startDate()
  if (moment(Vue.prototype.$startDate(copied.date.check_in)).isBefore(today)) {
    copied.date.check_in = new Date()
    if (moment(Vue.prototype.$startDate(copied.date.check_out)).isSameOrBefore(today)){
      copied.date.check_out = moment(copied.date.check_in).add(Vue.prototype.$defaultFilterBE('night'), 'd').toDate()
      store.commit("setBeFilter",copied)
    }else{
      store.commit("setBeFilter",copied) 
    }
  }
}


export function formatEmailValidation(data) {
  const mailformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let email = false
  if(data.match(mailformat))
  {
    email = true
  }else{
    email = false
  }
    return email
}

export function roomAvbl(room_type_id,room_rate_id,limit=false){
  let room_type_index = store.getters.getBeRoomAvbl.findIndex(x=>x.id == room_type_id)
  if(room_type_index != -1){

    let room_rate_index = store.getters.getBeCartRoom.findIndex(x=>x.room_rate.id == room_rate_id)
    let avlb = store.getters.getBeRoomAvbl[room_type_index].availability

    if(room_rate_index != -1){
      avlb = store.getters.getBeCartRoom[room_rate_index].qty + store.getters.getBeRoomAvbl[room_type_index].availability
    }

    if(limit){
      return (avlb < 6) ? avlb : 6
    }else{
      return avlb
    }
  }else{
    return 0
  }
}

export function calculateFinalPriceConcierge(price){
  if(price.tax_service_calculation_type == 'EXCLUDE'){
    if(parseInt(price.promotion_amount) == 0){
      return price.price_sell
    }else{
      return price.price_sell_final
    }
  }else{
    return price.price_sell_final_with_tax_service
  }
}

export function guestCounterCustom(guests){
  let guest_data = ''
  if(guests.adult > 0){
    guest_data += `${guests.adult} adults `
  }
  if(guests.child.length > 0){
    let print_age = ''
    for(let i = 0;i < guests.child.length;i++){
      if(i=0){
        print_age += `${guests.child[i]}`
      }else{
        if(guests.child.length > 2){
          if(i+1 == guests.child.length){
            print_age += `, and ${guests.child[i]}` 
          }else{
            print_age += `, ${guests.child[i]}`
          }
        }else{
          print_age += ` ${guests.child[i]}`
        }
      }
    }
    guest_data += `${guests.child.length} child (${print_age} year/s old)`
  }
  if(guests.infant > 0){
    guest_data += ` ${guests.infant} babies`
  }
  return guest_data
}

export function getRangeDates(start,end){
  let start_ = moment(start)
  let end_ = moment(end)
  let dur = moment.duration(end_.diff(start_)).days()
  let array_date = []
  for(let i = 0 ; i < dur ; i++){
    if(i==0){
      array_date.push(moment(start_).toDate())
    }else{
      let cr_date = moment(start_).add(i,'d').toDate()
      array_date.push(cr_date)
    }
  }
  return array_date
}

/**
 * @returns {boolean} true when the OS asks for reduced motion.
 */
export function prefersReducedMotion(){
  return typeof window !== 'undefined' &&
    !!window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

/**
 * @param {Object} filterA - a be_filter snapshot (date/guest/promo_code).
 * @param {Object} filterB - a be_filter snapshot to compare against.
 * @returns {boolean} true when both filters have the same values.
 */
export function isSameBeFilter(filterA, filterB) {
  return JSON.stringify(filterA) === JSON.stringify(filterB);
}

export const isNotEmpty = (data) => {
  if (data === null || data === undefined) {
    return false;
  }

  if (typeof data === 'string' && data.trim() === '') {
    return false;
  }

  if (Array.isArray(data) && data.length === 0) {
    return false;
  }

  if (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0) {
    return false;
  }

  return true;
}


// WEBPACK FOOTER //
// ./src/utils/index.js